import apiService from 'frontcore/data/api-service/api-service'

const createAPIService = () => {
  const match = window.location.pathname.match(/^(\/(apps\/web[\w-]+)?)\/?.*/gm)
  apiService.setGlobalConfiguration({
    backendVersion: API_VERSION,
    baseURL: API_URL,
    unauthorizedRedirectPath: match?.at(0) ?? '/',
  })
}

export default createAPIService
